export const StorageTransactionDirection = {
	backward: -1,
	forward: 1,
};
